import { Button, Dialog, styled } from '@mui/material';

export const CustomStyledDialog = styled(Dialog)({
  '.MuiDialogTitle-root': {
    backgroundColor: '#cce6e6',
  },
});

export const CustomStyledButton = styled(Button)({
  backgroundColor: '#F07B0E',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#f1785a',
  },
  width: 'fit-content',
});

export const isEmptyObject = (value) => {
  return value === null || value === undefined || (!(typeof value === 'object') && value?.trim() === '');
};

export const isEmpty = (value) => {
  return (
    value === null ||
    value === undefined ||
    (!Number.isInteger(value) &&
      typeof value !== 'boolean' &&
      !(value instanceof Date) &&
      !(typeof value === 'object') &&
      value?.trim() === '')
  );
};

export function calculateCompletionPercentage(leadDetails = {}, fields = []) {
  // Handle edge case where fields array is empty or leadDetails is empty
  if (fields.length === 0 || Object.keys(leadDetails).length === 0) {
    return 1;
  }

  // Count how many fields have a non-empty value
  const filledFields = fields.filter((field) => leadDetails[field]);

  // Calculate the percentage based on the number of filled fields
  const percentage = (filledFields.length / fields.length) * 100;

  // Ensure percentage is at least 1
  return Math.max(percentage, 1);
}
